export function getInformations() {
    return [
        "Users",
        "Groups",
        "Devices",
        "Applications"
    ]
}

export function getProperties(information) {
    const users = [
        "city",
        "companyName",
        "department",
        "displayName",
        "employeeId",
        "givenName",
        "isDeleted",
        "jobTitle",
        "licenses",
        "mail",
        "manager",
        "mobilePhone",
        "objectId",
        "onPremisesExtensionAttributes",
        "postalCode",
        "proxyAddresses",
        "signInActivity",
        "streetAddress",
        "surname",
        "userPrincipalName",
        "userType",
    ];

    const devices = [
        "deviceCategory",
        "displayName",
        "enrollmentType",
        "isCompliant",
        "isDeleted",
        "isManaged",
        "managementType",
        "manufacturer",
        "model",
        "operatingSystem",
        "operatingSystemVersion",
        "userId",
    ];

    const groups = [
        "displayName",
        "groupTypes",
        "isDeleted",
        "mail",
        "mailEnabled",
        "proxyAddresses",
        "securityEnabled",
    ];

    const applications = [
        "isRevoked",
        "principalDisplayName",
        "principalType",
        "resourceDisplayName",
        "userId",
    ];

    switch (information) {
        case 'Devices':
            return devices;
        case 'Users':
            return users;
        case 'Groups':
            return groups;
        case 'Applications':
            return applications;
    }
}

export function mapFieldToModel(field) {
    const map = {
        groupsId: "Groups",
        devicesId: "Devices",
        groupsOwnerId: "Groups",
        groupsModeratorId: "Groups",
        groupMembersOfId: "Groups",
        userId: "Users",
        ownerId: "Users"
    };

    return map[field];
}

export const relationMapping = {
    devicesId: {
        fields: ['displayName', 'operatingSystem'],
        separator: ' / ',
        excel: ['displayName', 'operatingSystem']
    },
    groupsId: {
        fields: ['displayName'],
        separator: ' / ',
        excel: 'displayName'
    },
    userId: {
        fields: ['displayName', 'type'],
        separator: ' / ',
        excel: 'displayName'
    },
    ownerId: {
        fields: ['displayName', 'type'],
        separator: ' / '
    },
    moderatorId: {
        fields: ['displayName', 'type'],
        separator: ' / '
    },
    delegationId: {
        fields: ['displayName', 'accessType'],
        separator: ' / ',
        excel: ['displayName', 'accessType'],
        excelNewLineForEachItem: true
    },
    applicationsId: {
        fields: ['resourceDisplayName'],
        separator: ' / '
    },
    groupsModeratorId: {
        fields: ['displayName'],
        separator: ' / ',
        excel: 'displayName'
    },
    groupsOwnerId: {
        fields: ['displayName'],
        separator: ' / ',
        excel: 'displayName'
    },
    roles: {
        fields: ['displayName', 'membership'],
        separator: ' / '
    },
    sponsors: {
        fields: ['userPrincipalName'],
        separator: ' / '
    },
    groupMembersOfId: {
        fields: ['displayName'],
        separator: ' / '
    }
}